export const USER_VERIFICATION_STATUS = {
  NONE: 0,
  DATA_ONLY: 1,
  IMAGE_UPLOADED: 2,
  WAITING_APPROVAL: 3,
  DONE: 20,
  REJECTED: 98,
  BANNED: 99
};

export const COMPANY_VERIFICATION_STATUS = {
  NONE: 0,
  DATA_ONLY: 1,
  IMAGE_UPLOADED: 2,
  WAITING_APPROVAL: 3,
  DONE: 20,
  REJECTED: 98
};

export const ACCOUNT_TYPE = {
  PERSONAL: 1,
  BUSINESS: 2,
  COMPANY: 3
};

export const TRANSACTIONS_VOLUME = {
  LOW: 1,
  MID: 2,
  HIGH: 3,

  MAX_FOUR_HUNDRED: 4,
  MAX_A_THOUSAND: 5,
  MAX_THREE_THOUSAND: 6,
  MAX_FIVE_THOUSAND: 7,
  MAX_TEN_THOUSAND: 8,
  MORE_THAN_TEN_THOUSAND: 9
};

export const ACCOUNT_TYPE_KEY = {
  [ACCOUNT_TYPE.PERSONAL]: "personal",
  [ACCOUNT_TYPE.BUSINESS]: "business",
  [ACCOUNT_TYPE.COMPANY]: "company"
};

export const PASSED_VERIF_STATUS = {
  PENDING: "pending",
  PASSED: "passed",
  NOT_PASSED: "not-passed"
};

export const ERROR_CODE_SUSPENDED_ACCOUNT = 1109;
export const ERROR_CODE_MONEY_TRANSFER_RESTRICTED = 1238;
export const ERROR_CODE_INTERNATIONAL_TRANSACTION_RESTRICTED = 1239;
